import {
    Box,
} from "@mui/material";

import CommonLayout from "layouts/DashboardLayout";
import React, {  useEffect } from "react";
import {  useSelector } from "react-redux";
import {  useSearchParams } from "react-router-dom";
import NoDataFound from "common/component/NoDataFound";
import CommonLoading from "components/common/CommonLoading";
import SubCategoriesGrid from "./GridView";
import SubCategoriesList from "./ListView";

export default function SubCategories() {
    const { categoriesList, loading = false } = useSelector((state) => state.category);
    const [searchParams, setSearchParams] = useSearchParams();
    const categoryView = searchParams?.get("categoryView") || "grid";


    useEffect(() => {
        setSearchParams({
            filter: searchParams.get("filter") ? searchParams.get("filter") : "manage_categories",
            categoryView: searchParams.get("categoryView") ? searchParams.get("categoryView") : "grid",
            categoryIds: searchParams.get("categoryIds") ? searchParams.get("categoryIds") : "",
            categoryTypes: searchParams.get("categoryTypes") ? searchParams.get("categoryTypes") : "",
            status: searchParams.get("status") ? searchParams.get("status") : "",
        });
    }, []);

   
    return (

        <CommonLayout>
                {/* <CategoryTabs /> */}
                {/* <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={3}>
                    <Grid item xs={12} sm={4}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <Typography variant="h4">Sub Categories</Typography>
                            <Stack direction="row" gap={1} className="grid-list-view" ml={2}>

                                <Tooltip title="Grid View">
                                    <div className="gl-view">
                                        <GridViewIcon
                                            onClick={() => {
                                                setSearchParams({
                                                    filter: searchParams?.get("filter"),
                                                    categoryView: "grid",
                                                });

                                                setSearchTerm("");
                                                searchTermRef.current = "";
                                                cannabinoidViewHandler("grid");
                                            }}
                                            color={categoryView === "grid" ? "primary" : ""}
                                        />
                                    </div>
                                </Tooltip>

                                <Tooltip title="list View">
                                    <div className="gl-view">
                                        <ViewListIcon
                                            onClick={() => {
                                                setSearchTerm("");
                                                searchTermRef.current = "";
                                                cannabinoidViewHandler("list");
                                                setSearchParams({
                                                    filter: searchParams?.get("filter"),
                                                    categoryView: "list",
                                                });
                                            }}
                                            color={categoryView === "list" ? "primary" : ""}
                                        />
                                    </div>
                                </Tooltip>
                            </Stack>
                        </Stack>
                    </Grid>
                 
                </Grid> */}
                {categoryView === "grid" ? <SubCategoriesGrid /> : <SubCategoriesList />}
                {/* Show no data message when there are no categories */}
                {!loading &&
                    (!categoriesList?.categories || categoriesList.categories.length === 0) && (
                        <NoDataFound />
                    )}
                {/* Show loading indicator */}
                {loading && <CommonLoading />}
        </CommonLayout>

    );
}
